import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@material-ui/core';
import { PropagateLoader } from 'react-spinners';
import { colors } from '../style';
export const Loader = (props) => {
    const { className, text } = props;
    return (_jsxs(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '250px', className: className || 'spinner-item', children: [_jsx(PropagateLoader, { size: 15, color: colors.secondary }), text && _jsx(Typography, { variant: 'h2', children: text })] }));
};
